/* Packages */
import React from 'react';
import { render } from 'react-dom';

const vehicleSearchNodes = Array.from(document.querySelectorAll('[data-vehicle-search]'));
if (vehicleSearchNodes.length) {
    import(/* webpackChunkName: "VehicleSearch" */ './components/VehicleSearch').then(({ default: VehicleSearch }) => {
        vehicleSearchNodes.forEach((node) => render(<VehicleSearch {...(JSON.parse(node.dataset.vehicleSearch || '{}'))} />, node));
    });
}
